var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5302 18.9698C15.5999 19.0395 15.6552 19.1222 15.6929 19.2132C15.7306 19.3043 15.75 19.4019 15.75 19.5004C15.75 19.599 15.7306 19.6965 15.6929 19.7876C15.6552 19.8786 15.5999 19.9614 15.5302 20.031C15.4606 20.1007 15.3778 20.156 15.2868 20.1937C15.1957 20.2314 15.0982 20.2508 14.9996 20.2508C14.9011 20.2508 14.8035 20.2314 14.7124 20.1937C14.6214 20.156 14.5387 20.1007 14.469 20.031L6.96899 12.531C6.89926 12.4614 6.84394 12.3787 6.80619 12.2876C6.76845 12.1966 6.74902 12.099 6.74902 12.0004C6.74902 11.9019 6.76845 11.8043 6.80619 11.7132C6.84394 11.6222 6.89926 11.5394 6.96899 11.4698L14.469 3.96979C14.6097 3.82906 14.8006 3.75 14.9996 3.75C15.1986 3.75 15.3895 3.82906 15.5302 3.96979C15.671 4.11052 15.75 4.30139 15.75 4.50042C15.75 4.69944 15.671 4.89031 15.5302 5.03104L8.55993 12.0004L15.5302 18.9698Z",
    fill: "#44546F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.ac18675c3a637409c9198beca6cbe992.svg";
export { ForwardRef as ReactComponent };